import styled, { css } from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConfigurationPanelHeaderWrapper = styled.div.withConfig({
  displayName: "ConfigurationPanelHeader__ConfigurationPanelHeaderWrapper"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["background:", ";position:absolute;width:100%;display:block;padding:", " ", ";border-block:", " solid ", ";border-inline-end:", " solid ", ";z-index:2;"], theme.color['fill-tertiary-hover'], theme.space['300'], theme.space['600'], theme.borderWidth['100'], theme.color['border-core-default'], theme.borderWidth['100'], theme.color['border-core-default']);
});
const ConfigurationPanelHeader = ({
  customLink,
  handleDone
}) => /*#__PURE__*/_jsx(ConfigurationPanelHeaderWrapper, {
  "data-test-id": "configuration-panel-header",
  children: /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsxs(Button, {
        id: "done-button",
        onClick: handleDone,
        use: "link",
        "data-test-id": "done-button",
        children: [/*#__PURE__*/_jsx(LeftIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `editor.form.config.panelHeader.done`
        })]
      })
    }), customLink && /*#__PURE__*/_jsx(Box, {
      "data-test-id": "property-link",
      children: customLink
    })]
  })
});
export default ConfigurationPanelHeader;